var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "contentBox",
    { attrs: { loading: !_vm.isLoaded, mainId: "unlock", noMt: true } },
    [
      _vm.isLoaded
        ? _c(
            "contentTitle",
            {
              attrs: {
                label: _vm.parcelUnlock ? "UNLOCK PARCEL" : "PURCHASE PLAN",
                labelClass: _vm.parcelUnlock ? "" : "text-white",
                close: "back",
                noScroll: true,
                noSticky: true
              }
            },
            [
              _vm.parcelUnlock
                ? _c(
                    "h2",
                    { staticClass: "text-white font-weight-light pb-2" },
                    [_vm._v(_vm._s(_vm.title))]
                  )
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoaded
        ? _c("contentBody", [
            _c("div", { staticClass: "plan-selection sticky-top shadow-dk" }, [
              _c("div", { staticClass: "row" }, [
                _vm.parcelUnlock
                  ? _c(
                      "div",
                      {
                        staticClass: "col plan-option",
                        class: { active: _vm.planSelected === "parcelUnlock" },
                        on: {
                          click: function($event) {
                            return _vm.planSelect("parcelUnlock")
                          }
                        }
                      },
                      [
                        _c("p", [_vm._v("ONE OFF")]),
                        _vm._v(" "),
                        _c("h4", [_vm._v("$9")])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col plan-option",
                    class: { active: _vm.planSelected === "dayPass" },
                    on: {
                      click: function($event) {
                        return _vm.planSelect("dayPass")
                      }
                    }
                  },
                  [
                    _c("p", [
                      _vm._v("DAY PASS "),
                      _vm.isPlanCurrent("dayPass")
                        ? _c("span", { staticClass: "badge badge-dark" }, [
                            _vm._v("ACTIVE")
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("h4", [_vm._v("$24")])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "col plan-option",
                    class: { active: _vm.planSelected === "studio" },
                    on: {
                      click: function($event) {
                        return _vm.planSelect("studio")
                      }
                    }
                  },
                  [
                    _c("p", [
                      _vm._v("STUDIO "),
                      _vm.isPlanCurrent("studio")
                        ? _c("span", { staticClass: "badge badge-dark" }, [
                            _vm._v("ACTIVE")
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("h4", [_vm._v("$99/mo")])
                  ]
                )
              ]),
              _vm._v(" "),
              _vm.isPlanCurrent("studio")
                ? _c("div", { staticClass: "plan-selected" }, [
                    _c("div", { staticClass: "px-3 py-2 text-left pb-1" }, [
                      _vm.planSelected === "parcelUnlock"
                        ? _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\tYou already have a studio subscription. This parcel is unlocked.\n\t\t\t\t\t"
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.planSelected === "dayPass"
                        ? _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\tYou already have a studio subscription. No need for a day pass.\n\t\t\t\t\t"
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.planSelected === "studio"
                        ? _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\tYou are currently on this plan.\n\t\t\t\t\t"
                            )
                          ])
                        : _vm._e()
                    ])
                  ])
                : _vm.isPlanCurrent("dayPass")
                ? _c("div", { staticClass: "plan-selected" }, [
                    _c("div", { staticClass: "px-3 py-2 text-left pb-1" }, [
                      _vm.planSelected === "parcelUnlock"
                        ? _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\tYou already have a day pass. This parcel is unlocked.\n\t\t\t\t\t"
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.planSelected === "dayPass"
                        ? _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\tYou are currently on this plan.\n\t\t\t\t\t"
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.planSelected === "studio"
                        ? _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\tUpgrade and get unlimited access to all Scoutred data.\n\t\t\t\t\t"
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm.planSelected === "studio"
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "text-left text-dark px-3 pb-3 bg-white"
                          },
                          [
                            _c("purchase", {
                              attrs: {
                                parcel: _vm.parcel,
                                plan: _vm.plans[_vm.planSelected]
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                : _c("div", { staticClass: "plan-selected" }, [
                    _c("div", { staticClass: "px-3 pt-2 text-left pb-1" }, [
                      _vm.planSelected === "parcelUnlock"
                        ? _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\tAccess data, features and reports on this parcel.\n\t\t\t\t\t"
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.planSelected === "dayPass"
                        ? _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\tAccess to all Scoutred data for "
                            ),
                            _c("strong", [_vm._v("24 hours")]),
                            _vm._v(".\n\t\t\t\t\t")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.planSelected === "studio"
                        ? _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\tUnlimited access to all Scoutred data.\n\t\t\t\t\t"
                            )
                          ])
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "text-left text-dark px-3 pb-3 bg-white" },
                      [
                        _c("purchase", {
                          attrs: {
                            parcel: _vm.parcel,
                            plan: _vm.plans[_vm.planSelected]
                          }
                        })
                      ],
                      1
                    )
                  ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "p-3" }, [
              _c("h4", { staticClass: "text-center pt-3" }, [
                _vm._v("SIMPLIFY DUE DILIGENCE")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "mt-0 mb-2" }, [
                _vm._v(
                  "\n\t\t\t\tPurchase a plan above to get access to premium Scoutred data and downloads:\n\t\t\t"
                )
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "mb-2 pl-1" }, [
                _c("li", [
                  _c("i", { staticClass: "material-icons md-18 mt-radio" }, [
                    _vm._v("check")
                  ]),
                  _vm._v(" Owner information")
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("i", { staticClass: "material-icons md-18 mt-radio" }, [
                    _vm._v("check")
                  ]),
                  _vm._v(" Permit data")
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("i", { staticClass: "material-icons md-18 mt-radio" }, [
                    _vm._v("check")
                  ]),
                  _vm._v(" Zoning and Overlays")
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("i", { staticClass: "material-icons md-18 mt-radio" }, [
                    _vm._v("check")
                  ]),
                  _vm._v(" Client-ready PDF download")
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("i", { staticClass: "material-icons md-18 mt-radio" }, [
                    _vm._v("check")
                  ]),
                  _vm._v(" AutoCAD DXF download")
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("i", { staticClass: "material-icons md-18 mt-radio" }, [
                    _vm._v("check")
                  ]),
                  _vm._v(" Parcel Dimensions "),
                  _c("span", { staticClass: "badge badge-dark" }, [
                    _vm._v("NEW")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("h5", { staticClass: "mb-2" }, [
                _vm._v("DAY AND STUDIO PASSES ONLY")
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "m-0 pl-1" }, [
                _c("li", [
                  _c("i", { staticClass: "material-icons md-18 mt-radio" }, [
                    _vm._v("check")
                  ]),
                  _vm._v(" Access to all parcels")
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("i", { staticClass: "material-icons md-18 mt-radio" }, [
                    _vm._v("check")
                  ]),
                  _vm._v(" Water and sewer line data")
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("i", { staticClass: "material-icons md-18 mt-radio" }, [
                    _vm._v("check")
                  ]),
                  _vm._v(" Bulk CSV data exports")
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "px-3 pb-3 pt-0" }, [
              _c("h4", { staticClass: "text-center pt-3" }, [
                _vm._v("ENTERPRISE & GOVERNMENT")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "mt-2 mb-2" }, [
                _vm._v(
                  "\n\t\t\t\tAre you an Enterprise or Government that needs access to:\n\t\t\t"
                )
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "mb-4 pl-1" }, [
                _c("li", [
                  _c("i", { staticClass: "material-icons md-18 mt-radio" }, [
                    _vm._v("check")
                  ]),
                  _vm._v(" Custom queries")
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("i", { staticClass: "material-icons md-18 mt-radio" }, [
                    _vm._v("check")
                  ]),
                  _vm._v(" Filtered permit searches and trend analysis")
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("i", { staticClass: "material-icons md-18 mt-radio" }, [
                    _vm._v("check")
                  ]),
                  _vm._v(" Scoutred's data via API")
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("i", { staticClass: "material-icons md-18 mt-radio" }, [
                    _vm._v("check")
                  ]),
                  _vm._v(" Custom mapping Vector Tiles")
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("i", { staticClass: "material-icons md-18 mt-radio" }, [
                    _vm._v("check")
                  ]),
                  _vm._v(" User management and unified billing")
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("i", { staticClass: "material-icons md-18 mt-radio" }, [
                    _vm._v("check")
                  ]),
                  _vm._v(" Something else?")
                ])
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "mb-0" }, [
                _vm._v(
                  "\n\t\t\t\tWe enjoy tackling large scale geospatial data problems and would love to talk. Give us a call at "
                ),
                _c("a", { attrs: { href: "tel:619-866-4543" } }, [
                  _vm._v("619-866-4543")
                ]),
                _vm._v(" or send an email to "),
                _c("a", { attrs: { href: "mailto:hello@scoutred.com" } }, [
                  _vm._v("hello@scoutred.com")
                ]),
                _vm._v(".\n\t\t\t")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "px-3 pb-5" }, [
              _c("div", { staticClass: "my-3 border-bottom-gray" }, [
                _vm._v(" ")
              ]),
              _vm._v(" "),
              _c("h4", { staticClass: "text-center mt-5" }, [
                _vm._v("WHAT PEOPLE ARE SAYING")
              ]),
              _vm._v(" "),
              _c("blockquote", { staticClass: "blockquote mx-4 mt-5" }, [
                _c("div", { staticClass: "mb-3" }, [
                  _c("img", {
                    staticClass: "rounded-circle mx-auto d-block",
                    staticStyle: { width: "80px", height: "80px" },
                    attrs: { src: require("../../assets/img/pedro.png") }
                  })
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "my-2" }, [
                  _vm._v(
                    '"Your database is amazing and saves several steps in the process I usually use to get info about a property. I’m actually in a state of disbelief at how thorough the information is."'
                  )
                ]),
                _vm._v(" "),
                _c("footer", { staticClass: "blockquote-footer" }, [
                  _vm._v("Pedro Tavres "),
                  _c("cite", { attrs: { title: "Source Title" } }, [
                    _vm._v("R&S Tavares Associates, Inc.")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("blockquote", { staticClass: "blockquote mx-3 mt-5" }, [
                _c("div", { staticClass: "mb-3" }, [
                  _c("img", {
                    staticClass: "rounded-circle mx-auto d-block",
                    staticStyle: { width: "80px", height: "80px" },
                    attrs: { src: require("../../assets/img/kim.png") }
                  })
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "my-2" }, [
                  _vm._v(
                    '"I love Scoutred. I was searching for parcel numbers and owner mailing addresses, and I was very happy to easily find exactly what I needed."'
                  )
                ]),
                _vm._v(" "),
                _c("footer", { staticClass: "blockquote-footer" }, [
                  _vm._v("Kimberly Rotter "),
                  _c("cite", { attrs: { title: "Source Title" } }, [
                    _vm._v("An Army of Writers")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "my-3 border-bottom-gray" }, [
                _vm._v(" ")
              ]),
              _vm._v(" "),
              _c("h4", { staticClass: "text-center mt-5" }, [_vm._v("FAQ")]),
              _vm._v(" "),
              _c("div", { staticClass: "font-weight-bold mt-4" }, [
                _vm._v(
                  "\n\t\t\t\t\tDoes the monthly subscription require a contract?\n\t\t\t\t"
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "mt-2" }, [
                _vm._v(
                  "\n\t\t\t\t\tAbsolutely not. We pride ourselves on making your life easier. If you want to change your plan you can do so anytime from your user preferences.\n\t\t\t\t"
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "font-weight-bold" }, [
                _vm._v(
                  "\n\t\t\t\t\tHow often is the data on Scoutred updated?\n\t\t\t\t"
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "mt-2" }, [
                _vm._v(
                  "\n\t\t\t\t\tDifferent data sets update at different intervals. The most dynamic data set is parcel ownership and is updated monthly. The rest of the datasets (i.e. zoning, overlays, etc.) are updated as new versions are released, usually quarterly or annually.\n\t\t\t\t"
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "font-weight-bold" }, [
                _vm._v(
                  "\n\t\t\t\t\tWhat geographic area does Scoutred cover?\n\t\t\t\t"
                )
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "mt-2" }, [
                _vm._v(
                  "\n\t\t\t\t\tCurrently Scoutred covers San Diego County and Los Angeles County and the majority of cities within those counties. We're planning on adding additional counties in the near future. Have a county you would like to see added? "
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "mailto:hello@scoutred.com?subject=County data request"
                    }
                  },
                  [_vm._v("Let us know!")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "font-weight-bold" }, [
                _vm._v("\n\t\t\t\t\tWhat if I have more questions?\n\t\t\t\t")
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "mt-2" }, [
                _vm._v("\n\t\t\t\t\tWe'd love to have a chat! You can "),
                _c(
                  "a",
                  {
                    attrs: {
                      href:
                        "mailto:hello@scoutred.com?subject=I need help with Scoutred"
                    }
                  },
                  [_vm._v("email us")]
                ),
                _vm._v(
                  ", anytime with any questions, comments or feedback you have.\n\t\t\t\t"
                )
              ])
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23803de2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23803de2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/unlock/unlock.vue
// module id = null
// module chunks = 